import { lazy } from 'react'

export const ActivityListPage = lazy(() => import('./ActivityListPage'))
